import { notEmpty } from '@ezchops/helpers';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import React, { useMemo } from 'react';
import { texts } from './intl';
export function Tags({ tags }) {
    const displayedTags = useMemo(() => [
        ...tags.level != null ? [texts.labels.tags.level[tags.level] ?? tags.level] : [],
        ...tags.genre ?? [],
        ...(tags.track ?? []).map(t => texts.labels.tags.track[t] ?? t),
        ...(tags.category ?? []).map(t => texts.labels.tags.category[t] ?? t),
    ].filter(notEmpty), [tags]);
    return React.createElement(TagsBox, { className: "Tags" }, displayedTags.map((a, i) => React.createElement(Chip, { key: i, label: a, size: "small", variant: "filled" })));
}
const TagsBox = styled(Box, {
    slot: 'Root',
    name: 'TagsBox'
})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    flexShrink: 1,
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
    '& .MuiChip-root': {
        height: 'auto',
        '&.MuiChip-filled': {
            backgroundColor: theme.palette.grey['A700'],
            color: theme.palette.getContrastText(theme.palette.grey['A700']),
            '&.MuiChip-sizeSmall': {
                height: '1em',
                '& .MuiChip-labelSmall': {
                    ...theme.typography.overline2,
                    padding: '3px 6px',
                }
            }
        }
    }
}));
//# sourceMappingURL=Tags.js.map